import { Lexer } from "@siteimprove/alfa-css";
import { Feature } from "@siteimprove/alfa-css-feature";
import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Rule } from "../rule.js";
import { ConditionRule } from "./condition.js";
/**
 * @public
 */
export class MediaRule extends ConditionRule {
    static of(condition, rules) {
        return new MediaRule(condition, Array.from(rules));
    }
    _queries;
    constructor(condition, rules) {
        super("media", condition, rules);
        this._queries = Feature.parseMediaQuery(Lexer.lex(condition))
            .map(([, queries]) => queries)
            .getOr(Feature.Media.List.of([]));
    }
    get queries() {
        return this._queries;
    }
    toJSON() {
        return super.toJSON();
    }
    toString() {
        const rules = this._rules
            .map((rule) => String.indent(rule.toString()))
            .join("\n\n");
        return `@media ${this._condition} {${rules === "" ? "" : `\n${rules}\n`}}`;
    }
}
/**
 * @public
 */
(function (MediaRule) {
    function isMediaRule(value) {
        return value instanceof MediaRule;
    }
    MediaRule.isMediaRule = isMediaRule;
    function matches(device) {
        return (rule) => rule.queries.matches(device);
    }
    MediaRule.matches = matches;
    /**
     * @internal
     */
    function fromMediaRule(json) {
        return Trampoline.traverse(json.rules, Rule.fromRule).map((rules) => MediaRule.of(json.condition, rules));
    }
    MediaRule.fromMediaRule = fromMediaRule;
})(MediaRule || (MediaRule = {}));
//# sourceMappingURL=media.js.map